import React, {FC} from 'react';

interface ICheckboxProps {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const Checkbox: FC<ICheckboxProps> = ({label, checked, disabled, onChange}) => (
  <label className="flex cursor-pointer items-center gap-2 py-0.5">
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className="h-4 w-4 flex-shrink-0 rounded border-[#dcdee5] accent-[#654dcb]"
    />
    <span className="text-[13px] text-[#33364b]">{label}</span>
  </label>
);
